import { api } from 'services';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getOrderList({
    cursor,
    end_date,
    limit,
    pickup_point_id,
    q,
    sort_by,
    start_date,
    status,
    statuses,
  } = {}) {
    const params = {
      cursor,
      end_date,
      limit,
      pickup_point_id,
      q,
      sort_by,
      start_date,
      status,
      statuses,
    };
    return api.get('/pickup_points/orders', { params: omitBy(params, isNil) });
  },

  getOrderDetails(id) {
    return api.get(`/pickup_points/orders/${id}`);
  },

  confirmArriveOrder(id) {
    return api.post(`/pickup_points/orders/${id}/arrived`);
  },
  completeOrder(id, payload) {
    return api.post(`/pickup_points/orders/${id}/complete`, payload);
  },
  resendPickupCode(id) {
    return api.post(`/pickup_points/orders/${id}/resend_pickup_code`);
  },
};
